import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { Grid, Stack } from '@mui/material';
import { SelectElement, SwitchElement, TextFieldElement, useWatch } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { fragmentsManageMessages } from '../../fragments-manage-messages';
import { MediaWatermarkFormValues } from '../types';

/** Watermark fields + save actions for the media watermark form. */
export function MediaWatermarkFormContent() {
  const { $t } = useIntl();
  const positionX = useWatch<MediaWatermarkFormValues, 'positionX'>({ name: 'positionX' });
  const positionY = useWatch<MediaWatermarkFormValues, 'positionY'>({ name: 'positionY' });

  const positionXOptions = [
    {
      id: 'left',
      label: $t({
        id: 'admin.fragments.watermark.positionLeft',
        defaultMessage: 'Izquierda',
      }),
    },
    {
      id: 'center',
      label: $t({
        id: 'admin.fragments.watermark.positionCenter',
        defaultMessage: 'Centro',
      }),
    },
    {
      id: 'right',
      label: $t({
        id: 'admin.fragments.watermark.positionRight',
        defaultMessage: 'Derecha',
      }),
    },
  ];

  const positionYOptions = [
    {
      id: 'top',
      label: $t({
        id: 'admin.fragments.watermark.positionTop',
        defaultMessage: 'Arriba',
      }),
    },
    {
      id: 'center',
      label: $t({
        id: 'admin.fragments.watermark.positionCenter',
        defaultMessage: 'Centro',
      }),
    },
    {
      id: 'bottom',
      label: $t({
        id: 'admin.fragments.watermark.positionBottom',
        defaultMessage: 'Abajo',
      }),
    },
  ];

  return (
    <Stack spacing={0}>
      <ContentCluster message={fragmentsManageMessages.watermarkImageTitle} divider={false}>
        <Stack spacing={2}>
          <SwitchElement
            name="enabled"
            label={$t({
              id: 'admin.fragments.watermark.active',
              defaultMessage: 'Activo',
            })}
          />

          <UploadAssetFieldMui
            name="imageUrl"
            label={$t({
              id: 'admin.fragments.watermark.loadLabel',
              defaultMessage: 'Cargar watermark',
            })}
            inputProps={{
              size: 'sm',
              accept: 'image/*',
              maxSizeMb: 1,
            }}
            assetLink
          />
        </Stack>
      </ContentCluster>

      <ContentCluster message={fragmentsManageMessages.watermarkPositionTitle}>
        <Stack spacing={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <SelectElement
                name="positionX"
                label={$t({
                  id: 'admin.fragments.watermark.positionX',
                  defaultMessage: 'Posición X',
                })}
                options={positionXOptions}
                fullWidth
                required
              />
            </Grid>
            {positionX !== 'center' && (
              <Grid item xs={12} md={3}>
                <TextFieldElement
                  name="paddingX"
                  label={$t({
                    id: 'admin.fragments.watermark.paddingX',
                    defaultMessage: 'Padding X',
                  })}
                  type="number"
                  fullWidth
                />
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <SelectElement
                name="positionY"
                label={$t({
                  id: 'admin.fragments.watermark.positionY',
                  defaultMessage: 'Posición Y',
                })}
                options={positionYOptions}
                fullWidth
                required
              />
            </Grid>
            {positionY !== 'center' && (
              <Grid item xs={12} md={3}>
                <TextFieldElement
                  name="paddingY"
                  label={$t({
                    id: 'admin.fragments.watermark.paddingY',
                    defaultMessage: 'Padding Y',
                  })}
                  type="number"
                  fullWidth
                />
              </Grid>
            )}
          </Grid>

          <Grid container>
            <Grid item xs={12} md={3}>
              <TextFieldElement
                name="opacity"
                label={$t({
                  id: 'admin.fragments.watermark.opacity',
                  defaultMessage: 'Opacidad',
                })}
                type="number"
                fullWidth
                inputProps={{ step: 0.1, min: 0, max: 1 }}
              />
            </Grid>
          </Grid>
        </Stack>
      </ContentCluster>

      <FormActionsMui
        saveLabel={$t({
          id: 'common.actions.save',
          defaultMessage: 'Guardar',
        })}
      />
    </Stack>
  );
}
